import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
const IconArrowRight = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-label="IconArrowRight"
    fill="currentColor"
    ref={ref}
    {...props}
  >
    <path d="M11.282 23.563a1.3 1.3 0 0 1-.387-.983c.01-.37.161-.722.424-.983l8-8.208H1.33a1.26 1.26 0 0 1-.94-.4 1.38 1.38 0 0 1-.388-1 1.33 1.33 0 0 1 .387-.965 1.26 1.26 0 0 1 .94-.4H19.32l-8-8.208a1.45 1.45 0 0 1-.424-1 1.32 1.32 0 0 1 .387-1 1.31 1.31 0 0 1 1.917 0l10.36 10.628q.202.2.332.454c.075.154.113.322.111.492 0 .176-.037.35-.11.511a1.7 1.7 0 0 1-.333.473L13.201 23.601a1.23 1.23 0 0 1-.959.4 1.36 1.36 0 0 1-.96-.438" />
  </svg>
);
const ForwardRef = /* #__PURE__ */ forwardRef(IconArrowRight);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
